import { EditChatTabNames, ChatDetailsResponse } from '@choco-admin/types';
import React from 'react';
import {
  FiUsers,
  FiSettings,
  FiShoppingCart,
  FiMessageSquare,
} from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';

interface EditChatTabsProps {
  activeTab: EditChatTabNames;
  chatData: ChatDetailsResponse;
}

export const EditChatTabs: React.FC<EditChatTabsProps> = ({
  activeTab,
  chatData,
}) => {
  const location = useLocation();
  const tabs = [
    {
      key: EditChatTabNames.PARTICIPANTS,
      title: 'Participants',
      icon: <FiUsers className="w-4 h-4" />,
    },
    {
      key: EditChatTabNames.SETTINGS,
      title: 'Settings',
      icon: <FiSettings className="w-4 h-4" />,
    },
    {
      key: EditChatTabNames.ORDER_GUIDE,
      title: 'Order Guide',
      icon: <FiShoppingCart className="w-4 h-4" />,
    },
    {
      key: EditChatTabNames.CHAT_HISTORY,
      title: 'Chat History',
      icon: <FiMessageSquare className="w-4 h-4" />,
    },
  ];

  return (
    <nav
      className="w-full border-b border-divider"
      role="tablist"
      aria-label="Edit chat tabs"
      aria-orientation="horizontal"
    >
      <div className="flex gap-6 relative p-0">
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.key;
          const tabUrl = `${location.pathname}#${tab.key}`;

          return (
            <Link
              key={tab.key}
              to={tabUrl}
              replace={true}
              role="tab"
              aria-selected={isActive}
              aria-controls={`${tab.key}ChatFormTabPanel`}
              id={`${tab.key}ChatFormTab`}
              className={`
                flex items-center space-x-2 px-0 h-12 text-sm font-medium transition-colors
                hover:text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
                ${
                  isActive
                    ? 'text-primary border-b-2 border-primary'
                    : 'text-foreground-500 hover:text-foreground-700'
                }
              `}
            >
              {tab.icon}
              <span>{tab.title}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
